import * as TaskRunner from 'util/TaskRunner';

export function downloadPlateRecordCSV({
  entryId,
  versionDbId,
  uuid,
}: {
  entryId: string;
  versionDbId: number;
  uuid: string | number;
}): JQueryPromise<{url: string}> {
  return TaskRunner.postJSON({
    url: `/1/api/entries/${entryId}/${versionDbId}/note-linked-plate-record/${uuid}:download`,
  });
}
